/* jshint esversion: 6 */
import React from 'react';
import Toggle from 'app/components/common/ToggleControl.jsx';
import InputEditorWrapper from 'app/mixins/InputEditorWrapper.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import InputBehaviorComponent from 'app/components/EditorComponents/InputBehaviorComponent.jsx';
import InstagramConfigPanel from 'app/components/EditorComponents/InstagramConfigPanel.jsx';
import FacebookPageConfigPanel from 'app/components/EditorComponents/FacebookPageConfigPanel.jsx';
import EchoComponent from 'app/components/EditorComponents/EchoComponent.jsx';
import * as _ from 'underscore';
import { compose } from 'redux';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

import ConfirmModal from 'app/components/common/ConfirmModal.jsx';

class InputDetailPanel extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			reauthClicked: false
		};

		this.reauthorizeInput = this.reauthorizeInput.bind(this)
	}

	reauthorizeInput(e) {
        let serviceId = e.currentTarget.dataset.serviceid,
            iaId = e.currentTarget.dataset.id,
			url = "/remote/beginreauth?isID=:isId&iaID=:iaId&state=:state&final=:final",
			date = new Date(),
			state = ['REAUTHINPUT', serviceId, iaId, date.getTime()].join("_"),
			constants = this.props.app.config.constants;

		e.preventDefault();
		e.stopPropagation();

		if (parseInt(serviceId) === constants.INPUT_TYPE_TWITTER &&
			this.props.app.config.twitterDisabled !== undefined &&
			this.props.app.config.twitterDisabled === 1) {
			this.props.closeAllModals();
			this.props.addModal(
				<ConfirmModal
					modalCopy="Twitter is currently unavailable. We're working to resolve this issue."
					cancelAction={() => {
						this.props.closeAllModals();
					}}
					showCancel={false}
					confirmAction={() => {
						this.props.closeAllModals();
					}}
					confirmLabel={"OK"}/>
			);
			return;
		}

		if (this.state.reauthClicked) {
			return;
		}

		this.setState({
			reauthClicked: true
		}, () => {
			url = url.replace(':isId', serviceId);
			url = url.replace(':iaId', iaId);
			url = url.replace(':state', state);
			url = url.replace(':final', window.encodeURIComponent(window.location.href));
			window.location.assign(url);
		});


    }

	render() {
		let constants = this.props.app.config.constants,
			feedName = (this.props.input && this.props.input.name) ? this.props.input.name : '',
			feedUrl = (this.props.input) ? this.props.input.url : '',
			feedActive = (this.props.input && this.props.input.activeFlag) ? true : false,
			reauth = null,
			nextPull = null,
			behavior = null,
			firstPullOptions = [],
			action = '',
			reauthButtonClass = '',
			echoControl = null,
			feedUrlElement = null,
			socialOverrides = null;

		if (!this.props.initialActiveState && feedActive && this.props.app.flags.routeViewType == constants.ROUTE_VIEW_ADVANCED) {
			if (parseInt(this.props.input.postFlag) === constants.POST_NOW) {
	            action = 'Post';
	        } else {
	            action = 'Queue';
	        }

			firstPullOptions = [
	            {value: constants.FIRSTPULL_SINGLE, label: action + ' the most recent item now'},
	            {value: constants.FIRSTPULL_OFF, label: action + ' when a new item is published'},
	            {value: constants.FIRSTPULL_ON, label: action + ' all items (up to max)'},
	        ];

			nextPull = (
				<fieldset>
	                <legend>Next Post</legend>
	                <StyledSelect
	                    options={firstPullOptions}
	                    linkedField={this.props.statePath + ".firstPullFlag"}
	                    value={this.props.input.firstPullFlag}
	                    selectClass="large"
	                    onChange={this.props.changeHandler}/>
	            </fieldset>
			);
		}


		if (!this.props.input.credID && [constants.INPUT_TYPE_TWITTER, constants.INPUT_TYPE_INSTAGRAM, constants.INPUT_TYPE_INSTAGRAM_BUSINESS, constants.INPUT_TYPE_FACEBOOK_PAGE].indexOf(parseInt(this.props.input.type)) !== -1) {
			if (this.props.input.sysActionFlag == 1) {
				reauthButtonClass = 'btn-primary fixed active';
			} else {
				reauthButtonClass = 'btn-secondary fixed active';
			}
			reauth = (
				<fieldset>
					<legend>Reconnect your input</legend>
					<button className={reauthButtonClass} onClick={this.reauthorizeInput} data-id={this.props.input.id} data-serviceid={this.props.input.type} role="button" aria-label="reconnect">
						Reconnect
					</button>
				</fieldset>
			)
			if (parseInt(this.props.input.type) === constants.INPUT_TYPE_INSTAGRAM_BUSINESS) {
				socialOverrides = (
					<InstagramConfigPanel
						{...this.props}
						onlySocialOverrides={true}/>
				);
			} else if (parseInt(this.props.input.type) === constants.INPUT_TYPE_FACEBOOK_PAGE) {
				socialOverrides = (
					<FacebookPageConfigPanel
						{...this.props}
						onlySocialOverrides={true}/>
				);
			}
		} else if (this.props.input.credID) {
			reauth = (
				<fieldset>
					<legend>Reconnect your input</legend>
					<div className="">We have fresh credentials for this feed. Hit save to finish the job!</div>
				</fieldset>
			)
		} else {
			feedUrlElement = (
				<fieldset>
					<legend>Feed URL<HelpButton which="feedUrl"/></legend>
					<p className="input-source">{feedUrl}</p>
				</fieldset>
			);
		}

		if (this.props.input.type !== constants.INPUT_TYPE_TWITTER) {
			echoControl = (
				<EchoComponent {...this.props}/>
			);
		}

		return (
			<div className="editor-panel">
				<form>
					{reauth}
					{feedUrlElement}
					<fieldset>
						<legend>Feed Name <span className="required">*</span></legend>
						<ErrorModule
                            app={this.props.app}
                            keys={['INPUT_CREATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="name" errors={state.errors}/>
                                );
                            }}/>
						<UncontrolledTextInput
							className="text-input medium"
							defaultValue={feedName}
							onChange={this.props.changeHandler}
							data-field={this.props.statePath + ".name"} />
					</fieldset>
					{socialOverrides}
					<InputBehaviorComponent
						{...this.props}
						input={this.props.input}
						changeHandler={this.props.changeHandler}
						statePath={this.props.statePath}
						showFirstPull={false}/>
					{nextPull}
					{echoControl}
					<fieldset>
						<legend>Feed Active</legend>
						<ErrorModule
                            app={this.props.app}
                            keys={['INPUT_CREATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="activeFlag" errors={state.errors}/>
                                );
                            }}/>
						<Toggle active={feedActive}
								noLabel={true}
								callback={this.props.changeHandler}
								linkedField={this.props.statePath + ".activeFlag"} />
					</fieldset>
					<fieldset>
						<div className="delete-block" onClick={this.props.deleteInput} role="button" aria-label="delete">
		                    <span className="delete-label">
		                        <i className="fa fa-trash"></i>
		                        Delete Feed
		                    </span>
		                </div>
					</fieldset>
				</form>
			</div>
		);
	}
};

InputDetailPanel.displayName = "InputDetailPanel";

const enhance = compose(
	ComponentWithContext,
	InputEditorWrapper
);

export default enhance(InputDetailPanel);
